{
  "add_prefix_space": false,
  "bos_token": "<|endoftext|>",
  "clean_up_tokenization_spaces": true,
  "eos_token": "<|endoftext|>",
  "model_max_length": 1024,
  "tokenizer_class": "GPT2Tokenizer",
  "unk_token": "<|endoftext|>"
}
